/* eslint-disable no-undef */

export default {
	name: "link-products-to-promotion-modal",
	props: ["heading", "modalId", "showModal", "isSaving", "promotionId", "productsLinkedToPromotion"],
	emits: ["saveClicked", "okClicked", "filterSearchClicked", "onActionClicked"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			searchQuery: null,
			products: [],
			linkedProducts: [],
			unlinkedProducts: [],
			productHeadings: [
				{
					text: "Product Code",
					field: "productId"
				},
				{
					text: "Barcode",
					field: "barcode"
				},
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Price",
					field: "priceAsString"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
		};
	},
	methods: {
		getProducts() {
			console.log("productsLinkedToPromotion", this.productsLinkedToPromotion)
			let request = {
				searchQuery: this.searchQuery,
				pageNum: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			productService.getProducts(request).then(response => {
				if(response.status === 200){
					this.products = response.data.result;
					this.products = dataTableHelper.castFieldValues(this.products);
					if(response.data.pagingInfo !== null) {
						this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
					}
					// for(let i = 0; i < this.products.length; i++) {
					// 	this.products[i].isLinked = false;
					// 	this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].amountIncludingVat);
					// }
					for(let i = 0; i < this.products.length; i++) {
						this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].amountIncludingVat);
						// for(let j = 0; j < this.productsLinkedToPromotion.length; j++) {
						// 	this.products[i].isLinked = this.products[i].productId === this.productsLinkedToPromotion[j].productId;
						// }
						if(this.productsLinkedToPromotion !== null && this.productsLinkedToPromotion !== undefined) {
							this.products[i].isLinked = this.productsLinkedToPromotion.some(product => product.productId === this.products[i].productId);
							if(this.products[i].isLinked){
								this.linkedProducts.push(this.products[i]);
							}
						}
					}
					// if(this.productsLinkedToPromotion !== null && this.productsLinkedToPromotion !== undefined){
					// 	for(let i = 0; i < this.products.length; i++) {
					// 		this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].amountIncludingVat);  
					// 		for(let j = 0; j < this.productsLinkedToPromotion.length; j++) {
					// 			this.products[i].isLinked = this.products[i].productId === this.productsLinkedToPromotion[j].productId;
					// 		}
					// 	}
					// }
					console.log("this.products", this.products);
				}
			});
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getProducts();
		},
		onModalCloseClick() {
			this.$emit("okClicked", true);
		},
		onModalSaveClick() {
			// var selectedProducts = [];
			// var unlinkedProducts = [];
			// for(let i = 0; i < this.products.length; i++) {
			// 	if(this.products[i].isLinked){
			// 		selectedProducts.push(this.products[i]);
			// 	}
			// 	else{
			// 		unlinkedProducts.push(this.products[i]);
			// 	}
			// }
			console.log("linkedProducts", this.linkedProducts);
			console.log("unlinkedProducts", this.unlinkedProducts);
			var selectedAndUnlinkedProducts = {
				selectedProducts: this.linkedProducts,
				unlinkedProducts: this.unlinkedProducts
			};
			this.$emit("saveClicked", selectedAndUnlinkedProducts);
		},
		onFilterSearchClicked(){
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getProducts();
		},
		onProductCheckOrUncheck(productId){
			for(let i = 0; i < this.products.length; i++) {
				if(this.products[i].productId === productId){
					this.products[i].isLinked = !this.products[i].isLinked;
					if(this.products[i].isLinked){
						this.unlinkedProducts.splice(this.unlinkedProducts.findIndex(product => product.productId === productId), 1);
						var hasProduct = this.linkedProducts.some(product => product.productId === this.products[i].productId);
						if(!hasProduct) {
							this.linkedProducts.push(this.products[i]);
						}
					}
					else{
						var hasUnlinkedProduct = this.unlinkedProducts.some(product => product.productId === this.products[i].productId);
						if(!hasUnlinkedProduct){
							this.unlinkedProducts.push(this.products[i]);
						}
					}
				}
				
			}
		}
	},
	mounted: function () {
        this.getProducts();
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		isSaving: {
			handler: function () {
				if(this.isSaving !== null && this.isSaving !== undefined){
					this.formIsSaving = this.isSaving;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		productsLinkedToPromotion:{
			handler: function () {
				// if(this.productsLinkedToPromotion !== null && this.productsLinkedToPromotion !== undefined){
				// 	for(let i = 0; i < this.products.length; i++) {
				// 		for(let j = 0; j < this.productsLinkedToPromotion.length; j++) {
				// 			if(this.products[i].productId === this.productsLinkedToPromotion[j].productId){
				// 				this.products[i].isLinked = true;
				// 				break;
				// 			}
				// 		}
				// 	}
				// }
				this.getProducts();
			},
			immediate: true,
			deep: true
		}
	}
};
